/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const PersonAlt = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12ZM12 10.5C13.933 10.5 15.5 8.933 15.5 7C15.5 5.067 13.933 3.5 12 3.5C10.067 3.5 8.5 5.067 8.5 7C8.5 8.933 10.067 10.5 12 10.5ZM3.5 19C3.5 16.7909 5.29086 15 7.5 15H16.5C18.7091 15 20.5 16.7909 20.5 19V19.3604C20.5 19.6058 20.3353 19.7698 20.1522 19.7986C18.3101 20.0892 15.1424 20.5 12 20.5C8.85757 20.5 5.68985 20.0892 3.84776 19.7986C3.66469 19.7698 3.5 19.6058 3.5 19.3604V19ZM2 19C2 15.9624 4.46243 13.5 7.5 13.5H16.5C19.5376 13.5 22 15.9624 22 19V19.3604C22 20.3138 21.3277 21.1318 20.3859 21.2803C18.5105 21.5761 15.2552 22 12 22C8.74476 22 5.48951 21.5761 3.61405 21.2803C2.67233 21.1318 2 20.3138 2 19.3604V19Z"
                        fill={color}
                    />
                </svg>
        );
    };
